import { CancelAllFiltersEvent } from './eventTypes/CancelAllFiltersEvent';
import { CancelFilterEvent } from './eventTypes/CancelFilterEvent';
import { SERPCloseEvent } from './eventTypes/CloseEvent';
import { SERPErrorEvent } from './eventTypes/ErrorEvent';
import { FilterEvent } from './eventTypes/FilterEvent';
import { GoToResultEvent } from './eventTypes/GoToResultEvent';
import { IndicesFilterEvent } from './eventTypes/IndicesFilterEvent';
import { OpenEvent } from './eventTypes/OpenEvent';
import { ResetQueryEvent } from './eventTypes/ResetQueryEvent';
import { SearchEvent } from './eventTypes/SearchEvent';

export const enum SERPEventType {
    OPEN = 'serp_open',
    CLOSE = 'serp_close',
    SEARCH = 'serp_search',
    GO_TO_RESULT = 'serp_goToResult',
    FILTER = 'serp_filter',
    INDICES_FILTER = 'serp_indicesFilter',
    CANCEL_FILTER = 'serp_cancelFilter',
    CANCEL_ALL_FILTERS = 'serp_cancelAllFilters',
    ERROR = 'serp_error',
    RESET_QUERY = 'serp_resetQuery',
}

export const enum SERPConfirmationEventType {
    GO_TO_RESULT_GA_CONFIRM = 'serp_goToResult_ga_confirm',
    GO_TO_RESULT_AA_CONFIRM = 'serp_goToResult_aa_confirm',
    CLOSE_GA_CONFIRM = 'serp_close_ga_confirm',
    CLOSE_AA_CONFIRM = 'serp_close_aa_confirm',
}

export type SERPEvent = CustomEvent &
    (
        | OpenEvent
        | SERPCloseEvent
        | SearchEvent
        | GoToResultEvent
        | FilterEvent
        | IndicesFilterEvent
        | CancelFilterEvent
        | CancelAllFiltersEvent
        | SERPErrorEvent
        | ResetQueryEvent
    );

export const isSERPEvent = (event: Event): event is SERPEvent =>
    typeof event === 'object' && event !== null && 'type' in event && event.type.startsWith('serp_');

/* CONFIRMABLE EVENTS */
export type SERPConfirmableEventDetail = {
    deliveryConfirmations: Array<SERPConfirmationEventType>;
};

export type SERPConfirmableEvent = CustomEvent<SERPConfirmableEventDetail>;

export const isConfirmableEvent = (event: CustomEvent): event is SERPConfirmableEvent =>
    'deliveryConfirmations' in event.detail &&
    Array.isArray(event.detail.deliveryConfirmations) &&
    event.detail.deliveryConfirmations.length > 0;
